// src\selectors\lists.js

import get from 'lodash/get';
import { createSelector } from 'reselect';

const getActiveNotDeleted = (entity) => entity && entity.active && !entity.deleted;

export const getIsLoadingList = (state) => get(state, 'assets.actions.isLoading', []);

export const getAccountsIds = (state) => get(state, 'listsNew.result.accounts', []);
export const getAccounts = (state) => get(state, 'listsNew.entities.accounts', {});

export const getCostCentersIds = (state) => get(state, 'listsNew.result.costCenters', []);
export const getCostCenters = (state) => get(state, 'listsNew.entities.costCenters', {});

export const getEmployeesIds = (state) => get(state, 'listsNew.result.employees', []);
export const getEmployees = (state) => get(state, 'listsNew.entities.employees', {});

export const getLocationsIds = (state) => get(state, 'listsNew.result.locations', []);
export const getLocations = (state) => get(state, 'listsNew.entities.locations', {});

export const getProjectsIds = (state) => get(state, 'listsNew.result.projects', []);
export const getProjects = (state) => get(state, 'listsNew.entities.projects', {});

export const getPhysicalStatesId = (state) => get(state, 'listsNew.result.physical_states', []);
export const getPhysicalStates = (state) => get(state, 'listsNew.entities.physical_states', {});

export const getProvidersIds = (state) => get(state, 'listsNew.result.providers', []);
export const getProviders = (state) => get(state, 'listsNew.entities.providers', {});

export const getCatalogs = (state) => get(state, 'listsNew.result.catalogs', {});
export const getElements = (state) => get(state, 'listsNew.entities.element', {});
export const getInpcs = (state) => get(state, 'listsNew.entities.inpcs', {});

export const getDepreciationsIds = (state) => get(state, 'listsNew.result.depreciations', []);
export const getDepreciations = (state) => get(state, 'listsNew.entities.depreciations', {});

export const getAsset_levelIds = (state) => get(state, 'listsNew.result.asset_levels', []);
export const getAsset_level = (state) => get(state, 'listsNew.entities.asset_level', {});

export const getVisibleElementsIds = createSelector([getElements], (els) =>
  Object.keys(els).filter((key) => getActiveNotDeleted(els[key]))
);

export const getVisibleElements = createSelector(
  [getVisibleElementsIds, getElements],
  (ids, elements) => ids.reduce((rs, id) => ({ ...rs, [id]: elements[id] }), {})
);

export const getCatalogsAndVisibleElements = createSelector(
  [getCatalogs, getVisibleElements],
  (catalogs, elements) =>
    Object.keys(catalogs).reduce(
      (rs, name) => ({
        ...rs,
        [name]: catalogs[name].map((el) => elements[el]),
      }),
      {}
    )
);

export const getVisibleAccounts = createSelector([getAccountsIds, getAccounts], (ids, accounts) =>
  ids.map((id) => accounts[id]).filter(getActiveNotDeleted)
);

export const getVisibleAccountsParent = createSelector([getVisibleAccounts], (accounts) =>
  accounts.filter((account) => !account._parent)
);

export const makeGetVisibleSubaccounts = () =>
  createSelector([getVisibleAccounts, (_, { accountId }) => accountId], (accounts, accountId) =>
    accounts.filter((account) => accountId && account._parent === accountId)
  );

export const getVisibleCostCenters = createSelector(
  [getCostCentersIds, getCostCenters],
  (ids, costCenters) => ids.map((id) => costCenters[id]).filter(getActiveNotDeleted)
);

export const getVisibleEmployees = createSelector(
  [getEmployeesIds, getEmployees],
  (ids, employees) => ids.map((id) => employees[id]).filter(getActiveNotDeleted)
);

export const getVisibleLocations = createSelector(
  [getLocationsIds, getLocations],
  (ids, locations) => ids.map((id) => locations[id]).filter(getActiveNotDeleted)
);

export const getVisibleLocationsParent = createSelector([getVisibleLocations], (locations) =>
  locations.filter((location) => !location.parent)
);

export const getVisibleProjects = createSelector([getProjectsIds, getProjects], (ids, projects) =>
  ids.map((id) => projects[id]).filter(getActiveNotDeleted)
);

export const getVisiblePhysicalState = createSelector([getCatalogsAndVisibleElements], (catalogs) =>
  (catalogs.physicalState || []).filter(getActiveNotDeleted)
);

export const getVisibleProviders = createSelector(
  [getProvidersIds, getProviders],
  (ids, providers) => ids.map((id) => providers[id]).filter(getActiveNotDeleted)
);

export const makeVisibleSublocations = () =>
  createSelector([getVisibleLocations, (_, { location }) => location], (locations, parent) =>
    locations.filter((location) => location.parent === parent)
  );

export const getVisibleDepreciations = createSelector(
  [getDepreciationsIds, getDepreciations],
  (ids, depreciations) => ids.map((id) => depreciations[id])
  //.filter(depreciation => depreciation.active && !depreciation.deleted)
);

export const getVisibleAssetLevels = createSelector(
  [getAsset_levelIds, getAsset_level],
  (ids, asset_level) => ids.map((id) => asset_level[id]).filter(getActiveNotDeleted)
  //.filter(depreciation => depreciation.active && !depreciation.deleted)
);

export const getVisibleStatus = createSelector(
  [getCatalogsAndVisibleElements],
  (catalogs) => catalogs.status || []
);

export const getVisibleCoins = createSelector(
  [getCatalogsAndVisibleElements],
  (catalogs) => catalogs.coin || []
);



// WEBPACK FOOTER //
// src/selectors/lists.js